export const GMAP_ASYNC_BUNDLE_KEY = "gmaps";

export const GMAP_API_KEY = "AIzaSyCjv7fvJvzK_qyqglqORUNf_SAT9q_PEzo"; // acanto: "AIzaSyCpsJMLjL9wOnLhaw9lYzFYTmhb3nFm7pY";

export const GMAP_SCRIPT_URL = `https://maps.googleapis.com/maps/api/js?key=${GMAP_API_KEY}&libraries=places,geometry`;

export const GMAP_USA_CENTER = {
  lat: 39.62005487761207,
  lng: 13.398838233597337,
};

export const GMAP_USA_BOUNDS = {
  north: 49.86, // 49.38,
  south: 23.62, // 25.82,
  east: -69.09, // -66.94,
  west: -126.22, // -124.39,
};
